export function SectionLabel({ children, light = false, num, className = "" }) {
  return (
    <div className={`label flex items-center gap-4 ${light ? "text-blush" : "text-terracotta"} ${className}`}>
      {num && <span className="opacity-70">{num}</span>}
      <span className={`h-px w-8 ${light ? "bg-blush/50" : "bg-terracotta/50"}`} />
      <span>{children}</span>
    </div>
  );
}

export function Marquee({ items = ["Contrôle", "Ligne", "Force"], light = false }) {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className={`overflow-hidden border-y ${light ? "border-petal/15" : "border-onyx/10"} py-6`} aria-hidden="true">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {row.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-serif italic text-4xl md:text-6xl px-8 ${light ? "text-petal" : "text-onyx"}`}>{it}</span>
            <span className={`font-serif text-3xl ${light ? "text-terracotta" : "text-terracotta"}`}>·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
